import { useQuery } from "@tanstack/react-query";

import MetaDatasetService from "services/MetaDataset";

export const SWOOGO_EVENT_DATASETS_QUERY_KEY = "swoogo-event-datasets";

const EMPTY = new Map();

// The ids are sorted so every caller that asks for the same events, such as
// each cell of one table page, shares a single request.
export default function useSwoogoEventDatasets(
  eventIds,
  { enabled = true } = {}
) {
  const sortedIds = [...eventIds].sort((a, b) => a - b);
  const { data, isSuccess } = useQuery({
    queryKey: [SWOOGO_EVENT_DATASETS_QUERY_KEY, sortedIds],
    queryFn: () => MetaDatasetService.getSwoogoEventDatasets(sortedIds),
    enabled: enabled && sortedIds.length > 0,
  });
  const links = data
    ? new Map(data.map(link => [link.swoogo_event_id, link]))
    : EMPTY;
  return { links, isLoaded: isSuccess };
}
